import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";

// use this as a sample to provide the master key for your report
const exampleMasterKey = [
  { key: "C", value: "Test completed, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  { key: "B", value: "Baseline data matches that recorded during the most recent Baseline test, so full test not required." },
  { key: "G", value: "Governed by Special Instruction." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "N", value: "Test Not Applicable." },
  { key: "NI", value: "No Inspection Required." },
  { key: "CO", 
    value: "Compliant" },
  { key: "NC", value: "Not compliant" },
  { key: "P", value: "Pass" },
  { key: "F", value: "Fail" },
];

const ReportFraConditionsMasterKey = ({ masterKey, title }) => {
  return (
    <Fragment>
      <span className="spacer"></span>
      <Row>
        <Col md={12}>
          <div className="fra-masterkey-title">
            <span>{title || "Conditions Master Key"}</span>
          </div>
          <div className="fra-masterkey-values">
            {masterKey.map((item, i) => (
              <div key={i}>
                <span style={{ width: "30px", display: "inline-block" }}>{item.key}</span>
                <span>{` --  ${item.value}`}</span>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ReportFraConditionsMasterKey;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ReportFraConditionsMasterKey.jsx